import React from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import ReactTable from 'react-table';
import MenuCalender from '../menuCalender/menuCalender';
import {isRegularLunchOrderType, getNotWorkingDays} from '../../../../../server/util.js';


function ByItemAccordion(props) {
    let { items, columns, filterBy, date, orderedMenu } = props;
    return (
        (items||[]).length<=0?
            <div className="row">
                <div className="col-md-12 text-center">
                    <span>No data available</span>
                </div>
            </div>:
            <div className="row">
                <div className="col-md-12">            
                    <Accordion accordion={false}>
                        {items.map(e => (<AccordionItem expanded={true}>
                            <AccordionItemTitle style={{ textAlign: 'center' }}>
                                <h3>{e.item}</h3>
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                <p>
                                    {e.itemBody||''}
                                </p>
                                {filterBy == 'Weekly' ? <ReactTable
                                    data={[e||{}]}
                                    columns={columns||[]}
                                    defaultPageSize={1}
                                    className="-striped -highlight"
                                    noDataText='No data found'
                                    showPagination={false}
                                /> : 
                                <MenuCalender date={date} orderedMenu={e.orderedMenu||[]}
                                hiddenDays={getNotWorkingDays()} />}
                            </AccordionItemBody>
                        </AccordionItem>))}
                    </Accordion>
                </div>
            </div>
    );
}

export default ByItemAccordion;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/ByItemAccordion/ByItemAccordion.jsx